import * as R from 'ramda';

export const inputTimeToArrayData = R.curry((caracter:string, inputValue: string): number[] => {
  if (R.isNil(inputValue) || R.isEmpty(inputValue)) return [];

  return inputValue
    .split(caracter)
    .map(dateInfo => parseInt(dateInfo, 10));
});
